import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lg:container lg:mx-auto pt-10 md:pt-12 flex justify-center items-center px-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-4" }, "Restricted area", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-12" }, " Only authorized users can access this area of the website. Please, use Metamask to authorize. ", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Authorize")
const _hoisted_5 = {
  key: 1,
  class: "w-full"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-2" }, "Rewards distribution", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Reset and calculate again")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_bal_card = _resolveComponent("bal-card")!
  const _component_bal_select_input = _resolveComponent("bal-select-input")!
  const _component_BalTabs = _resolveComponent("BalTabs")!
  const _component_bal_table = _resolveComponent("bal-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.state.user)
      ? (_openBlock(), _createBlock(_component_bal_card, {
          key: 0,
          class: "py-6 px-4 w-full md:w-96"
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _hoisted_3,
            (!_ctx.state.user)
              ? (_openBlock(), _createBlock(_component_BalBtn, {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.authorize())),
                  loading: _ctx.state.loading,
                  loadingLabel: "Loading...",
                  class: "w-full"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["loading"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.state.user)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_BalBtn, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.reset())),
            class: "mb-4 float-right"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_bal_card, { class: "w-full" }, {
            default: _withCtx(() => [
              _createVNode(_component_bal_select_input, {
                options: _ctx.phases,
                modelValue: _ctx.activePhase,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.activePhase = $event)),
                name: "Phase"
              }, null, 8, ["options", "modelValue"]),
              _createVNode(_component_BalTabs, {
                modelValue: _ctx.activeTab,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeTab = $event)),
                tabs: _ctx.tabs,
                class: "pt-4 mb-6",
                "no-pad": ""
              }, null, 8, ["modelValue", "tabs"]),
              (_ctx.activeTab === 'trade')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_BalBtn, {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.payOutTrading(_ctx.activePhase))),
                      loading: _ctx.state.loading,
                      loadingLabel: "Loading..."
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Pay out Phase " + _toDisplayString(parseInt(_ctx.activePhase, 10)), 1)
                      ]),
                      _: 1
                    }, 8, ["loading"]),
                    _createVNode(_component_bal_table, {
                      columns: _ctx.state.tradingRewardsColumns,
                      data: _ctx.state.tradingRewards
                    }, null, 8, ["columns", "data"])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}